import Spinner from 'src/javascripts/components/utilities/Spinner'

export default class ExportsTemplatesRowFiltersIndex {

  constructor() {}

  render() {

    // Reload page when table name changes to update column options
    // Include selected table_name= in URL params
    $('#export_template_rows_table').on('change', (e) => {
      $('.modal-body').css('opacity', '0.3');
      Spinner('.modal-content');
      let rowsTable = e.target.value;
      let url = new URL(window.location.href);
      url.searchParams.set('rows_table', rowsTable);
      Turbo.visit(url.toString());
    });

    // Change destroy to false when edit a filter
    $('.export-template-filter').bind('typeahead:select typeahead:autocomplete', function(ev, suggestion) {
      const inputGroup = ev.target.closest('.input-group');
      const destroyField = inputGroup.querySelector('input[name*="_destroy"]');
      if (destroyField) {
        destroyField.value = '0';
      }
    });

    // Clear Sector, Industry, or Sub-industry filter and hidden field when one of the other two are changed
    $('.export-template-hierarchy-filter').on('typeahead:select typeahead:autocomplete', function(ev, suggestion) {
      const changedInput = $(ev.currentTarget);
      let changedId = changedInput.attr('id');
      $('.export-template-hierarchy-filter').each(function() {
        const currentInput = $(this);
        const currentId = currentInput.attr('id');
        const inputGroup = currentInput.closest('.input-group');
        const destroyField = inputGroup.find('input[name*="_destroy"]')[0];

        if (currentId === changedId) {
          if (destroyField) { destroyField.value = '0'; }
          return;
        }

        currentInput.typeahead('val', '');
        if (destroyField) { destroyField.value = '1'; }
      });
    });

    // Change destroy to true when clear typeahead clicked
    $('.clear-export-filter-typeahead').on('click', (e) => {
      const inputGroup = $(e.target).closest(".input-group");
      const destroyField = inputGroup.find('input[name*="_destroy"]')[0];
      const inputField = inputGroup.find(".twitter-typeahead input");
      if (destroyField) {
        destroyField.value = '1';
      }
      if (inputField) {
        inputField.typeahead("val", "");
      }

    });

  }

}
